/* ==========================================================================
   AULBERY — header section scripts  (as-header.js)
   Moved 1:1 from sections/header.liquid: the 431 mega panel controller,
   drawer height lock and selector auto-submit; Dawn's StickyHeader element;
   the mobile scroll-progress bar. Thresholds come from data-* attributes on
   the [data-as-header] root (defaults = the old literals).
   ========================================================================== */

/* 431 — mega panel controller, drawer height lock, selector auto-submit.
   Document-level listeners bind once; per-element listeners re-bind after
   a theme-editor re-render. */
(function () {
  var AS = (window.ASHeaderMenus = window.ASHeaderMenus || {});

  /* thresholds — read at call time so an editor re-render picks up new values */
  AS.cfg = function () {
    var root = document.querySelector('[data-as-header]');
    var d = root ? root.dataset : {};
    function num(v, fb) {
      var n = parseFloat(v);
      return isNaN(n) ? fb : n;
    }
    return {
      closingMs: num(d.asMegaClosingMs, 460),
      minRoom: num(d.asMegaMinRoom, 160),
      bottomGap: num(d.asMegaBottomGap, 24),
      scrollClose: num(d.asMegaScrollClose, 60),
      drawerMinH: num(d.asDrawerMinH, 120),
      mobileMax: num(d.asMobileMax, 989)
    };
  };

  AS.open = function (item, how) {
    clearTimeout(AS.openT);
    clearTimeout(AS.closeT);
    clearTimeout(AS.closingT);
    if (AS.current === item) {
      if (how === 'click') AS.how = 'click';
      return;
    }
    var nav = item.closest('[data-asm-nav]');
    var cfg = AS.cfg();

    /* switching: drop the old item without collapsing the sheet */
    var prev = AS.current;
    if (prev) {
      prev.classList.remove('is-open');
      var pt = prev.querySelector('[data-asm-trigger]');
      if (pt) pt.setAttribute('aria-expanded', 'false');
    }

    AS.current = item;
    AS.how = how;
    AS.scrollStart = window.pageYOffset || 0;

    var wrap = item.closest('.header-wrapper');
    var panel = item.querySelector('[data-asm-panel]');
    var inner = panel ? panel.firstElementChild : null;
    if (wrap && nav) {
      var r = wrap.getBoundingClientRect();
      var room = Math.max(cfg.minRoom, Math.round(window.innerHeight - r.bottom - cfg.bottomGap));
      var h = inner ? Math.min(inner.offsetHeight, room) : 0;
      item.style.setProperty('--asm-max-h', room + 'px');
      nav.style.setProperty('--asm-panel-h', h + 'px');
      nav.style.setProperty('--asm-top', Math.round(r.bottom) + 'px');
      wrap.preventHide = true; /* Dawn's StickyHeader won't hide while open */
    }

    if (nav) {
      nav.classList.remove('is-closing');
      nav.classList.add('is-active');
    }
    item.classList.add('is-open');
    var t = item.querySelector('[data-asm-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
  };

  AS.close = function (item) {
    clearTimeout(AS.openT);
    clearTimeout(AS.closeT);
    if (!item) return;
    item.classList.remove('is-open');
    var t = item.querySelector('[data-asm-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
    if (AS.current !== item) return;

    AS.current = null;
    var nav = item.closest('[data-asm-nav]');
    if (nav) {
      nav.classList.remove('is-active');
      nav.classList.add('is-closing');
      clearTimeout(AS.closingT);
      AS.closingT = setTimeout(function () {
        nav.classList.remove('is-closing');
      }, AS.cfg().closingMs);
    }
    var wrap = item.closest('.header-wrapper');
    if (wrap) wrap.preventHide = false;
  };

  /* Drawer height, locked in px. Uses the drawer's own computed top (the
     same calc the CSS uses), so the value set before opening and after
     opening always match — no mid-slide jump. */
  AS.lockDrawer = function () {
    var cfg = AS.cfg();
    if (window.innerWidth > cfg.mobileMax) return;
    var d = document.getElementById('menu-drawer');
    if (!d) return;
    var top = parseFloat(window.getComputedStyle(d).top);
    if (isNaN(top)) {
      var h = document.querySelector('.section-header');
      top = h ? h.getBoundingClientRect().bottom : 0;
    }
    var px = Math.round(window.innerHeight - top);
    if (px > cfg.drawerMinH) document.documentElement.style.setProperty('--as-drawer-h', px + 'px');
  };

  /* Put the drawer fully back to closed. Every change is guarded so it
     never re-triggers the observer below. */
  AS.syncDrawerClosed = function (dt) {
    if (!dt) return;
    var sum = dt.querySelector(':scope > summary');
    if (sum && sum.getAttribute('aria-expanded') !== 'false') sum.setAttribute('aria-expanded', 'false');
    if (dt.classList.contains('menu-opening')) dt.classList.remove('menu-opening');
    if (dt.classList.contains('as-open')) dt.classList.remove('as-open');
    ['overflow-hidden-tablet', 'overflow-hidden-desktop'].forEach(function (c) {
      if (document.body.classList.contains(c)) document.body.classList.remove(c);
    });
    var hdr = document.querySelector('.section-header');
    if (hdr && hdr.classList.contains('menu-open')) hdr.classList.remove('menu-open');
  };

  /* Dawn adds .menu-opening in the same moment the drawer first renders,
     so a CSS transition keyed to it has no "closed" frame to start from
     and pops. We mirror it as .as-open one frame later instead. */
  AS.watchDrawer = function () {
    var dt = document.getElementById('Details-menu-drawer-container');
    if (!dt || dt.dataset.asWatch === '1') return;
    dt.dataset.asWatch = '1';
    var sheet = dt.querySelector('.as-dsheet');
    var pending = false;

    AS.drawerObserver = new MutationObserver(function () {
      var isOpen = dt.hasAttribute('open');
      var opening = isOpen && dt.classList.contains('menu-opening');

      if (opening && !dt.classList.contains('as-open') && !pending) {
        pending = true;
        AS.lockDrawer();
        if (sheet) void window.getComputedStyle(sheet).transform; /* commit the closed frame */
        requestAnimationFrame(function () {
          pending = false;
          if (dt.hasAttribute('open') && dt.classList.contains('menu-opening')) dt.classList.add('as-open');
        });
      } else if (!opening && dt.classList.contains('as-open')) {
        dt.classList.remove('as-open');
      }

      if (!isOpen) AS.syncDrawerClosed(dt);
    });
    AS.drawerObserver.observe(dt, { attributes: true, attributeFilter: ['open', 'class'] });
  };

  AS.init = function () {
    AS.watchDrawer();
    var nav = document.querySelector('[data-asm-nav]');
    if (!nav || nav.dataset.asmInit === '1') return;
    nav.dataset.asmInit = '1';
    AS.current = null;

    var openMs = parseInt(nav.dataset.openDelay, 10) || 0;
    var closeMs = parseInt(nav.dataset.closeDelay, 10) || 0;

    Array.prototype.forEach.call(nav.querySelectorAll('[data-asm-item]'), function (item) {
      var t = item.querySelector('[data-asm-trigger]');
      var panel = item.querySelector('[data-asm-panel]');
      if (!t || !panel) return;

      /* mouse hover — touch and pen never open on hover */
      item.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(AS.closeT);
        clearTimeout(AS.openT);
        if (AS.current === item) return;
        AS.openT = setTimeout(function () {
          AS.open(item, 'hover');
        }, AS.current ? 0 : openMs);
      });

      item.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(AS.openT);
        if (AS.current !== item || AS.how !== 'hover') return;
        AS.closeT = setTimeout(function () {
          AS.close(item);
        }, closeMs);
      });

      /* click / tap / Enter / Space */
      t.addEventListener('click', function (e) {
        e.preventDefault();
        if (AS.current === item) {
          if (AS.how === 'hover') {
            AS.how = 'click'; /* a click on a hover-opened panel pins it */
            return;
          }
          AS.close(item);
        } else {
          AS.open(item, 'click');
        }
      });

      /* keyboard focus */
      t.addEventListener('focus', function () {
        var kb = false;
        try { kb = t.matches(':focus-visible'); } catch (err) {}
        if (kb && AS.current !== item) AS.open(item, 'focus');
      });

      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowDown') return;
        e.preventDefault();
        AS.open(item, 'click');
        requestAnimationFrame(function () {
          var first = panel.querySelector('a[href]');
          if (first) first.focus();
        });
      });

      /* tabbing out of the item closes it */
      item.addEventListener('focusout', function (e) {
        var to = e.relatedTarget;
        if (to && !item.contains(to) && AS.current === item) AS.close(item);
      });
    });
  };

  /* editor: the section is about to be replaced — drop timers and the
     drawer observer so nothing fires against detached nodes */
  AS.teardown = function () {
    clearTimeout(AS.openT);
    clearTimeout(AS.closeT);
    clearTimeout(AS.closingT);
    if (AS.drawerObserver) {
      AS.drawerObserver.disconnect();
      AS.drawerObserver = null;
    }
    AS.current = null;
  };

  if (!AS.bound) {
    AS.bound = true;

    document.addEventListener('pointerdown', function (e) {
      if (AS.current && !AS.current.contains(e.target)) AS.close(AS.current);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !AS.current) return;
      var item = AS.current;
      var t = item.querySelector('[data-asm-trigger]');
      var hadFocus = item.contains(document.activeElement);
      AS.close(item);
      if (hadFocus && t) t.focus();
    });

    window.addEventListener('scroll', function () {
      if (AS.current && Math.abs((window.pageYOffset || 0) - AS.scrollStart) > AS.cfg().scrollClose) AS.close(AS.current);
    }, { passive: true });

    /* width changes only — mobile fires resize on scroll */
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastW) return;
      lastW = window.innerWidth;
      if (AS.current) AS.close(AS.current);
      AS.lockDrawer();
    });

    /* hamburger taps */
    document.addEventListener('click', function (e) {
      var sum = e.target.closest && e.target.closest('#Details-menu-drawer-container > summary');
      if (!sum) return;
      var dt = sum.parentNode;
      /* mid-close (still [open], slide already reversing): ignore the tap.
         Dawn would read it as another close and the state tangles. */
      if (dt.hasAttribute('open') && !dt.classList.contains('menu-opening')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      /* about to open: lock the height before it slides in */
      if (!dt.hasAttribute('open')) AS.lockDrawer();
    }, true);

    /* drawer finished closing: clean up anything Dawn left behind */
    document.addEventListener('toggle', function (e) {
      var dt = e.target;
      if (!dt || dt.id !== 'Details-menu-drawer-container') return;
      if (dt.open) AS.lockDrawer();
    }, true);

    /* back button restoring a page that was left with the drawer open */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var dt = document.getElementById('Details-menu-drawer-container');
      if (dt && dt.hasAttribute('open')) {
        dt.removeAttribute('open');
        AS.syncDrawerClosed(dt);
      }
    });

    /* selector: Shopify's localization form does the work, this submits it */
    document.addEventListener('change', function (e) {
      var sel = e.target.closest && e.target.closest('[data-asl-select]');
      if (!sel || !sel.form) return;
      if (typeof sel.form.requestSubmit === 'function') sel.form.requestSubmit();
      else sel.form.submit();
    });

    /* theme editor */
    document.addEventListener('shopify:section:load', function () {
      AS.init();
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-as-header]')) AS.teardown();
    });
    document.addEventListener('shopify:block:select', function (e) {
      var item = e.target && e.target.closest && e.target.closest('[data-asm-item]');
      if (item) AS.open(item, 'click');
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var item = e.target && e.target.closest && e.target.closest('[data-asm-item]');
      if (item && AS.current === item) AS.close(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', AS.init);
  } else {
    AS.init();
  }
})();

/* Dawn's StickyHeader (from the section's {% javascript %} block). Defined
   once, guarded, so a second load of this asset can never redefine it. */
(function () {
  if (window.customElements.get('sticky-header')) return;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      /* Dawn: an open predictive search keeps the header where it is (no-op
         unless the "Show search" contract is on) */
      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    /* Dawn: close the search modal when the header hides (no-op unless the
       "Show search" contract is on) */
    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  window.customElements.define('sticky-header', StickyHeader);
})();

// Scroll progress (mobile bar in the header)
(function () {
  if (window.ASHeaderScrollProgress) return;
  window.ASHeaderScrollProgress = true;
  var ticking = false;
  function update() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    var p = max > 0 ? Math.min(1, Math.max(0, (window.pageYOffset || doc.scrollTop) / max)) : 0;
    doc.style.setProperty('--as-scroll', p);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();

